import { useSyncExternalStore } from 'react';
import { getLocalStorage, putLocalStorage } from 'utils/localStorage';

const listeners = new Set<() => void>();
const readStoredValue = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  const stored = getLocalStorage('show_archived_entries');
  return stored?.value ?? false;
};

const writeStoredValue = (value: boolean) => {
  if (typeof window === 'undefined') {
    return;
  }
  putLocalStorage('show_archived_entries', { value });
};

let cachedValue = readStoredValue();

const emitChange = () => {
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => cachedValue;

const setShowArchived = (value: boolean) => {
  cachedValue = value;
  writeStoredValue(value);
  emitChange();
};

export const useShowArchivedPreference = () => {
  const showArchived = useSyncExternalStore(
    subscribe,
    getSnapshot,
    getSnapshot
  );

  return { showArchived, setShowArchived };
};
